import { atomWithStorage } from 'jotai/utils'

export const membershipEntryPointBannerDismissedAtom = atomWithStorage<boolean | undefined>(
  'membershipEntryPointBannerDismissed',
  false,
)
membershipEntryPointBannerDismissedAtom.debugLabel = 'membershipEntryPointBannerDismissedAtom'
